import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import { Clipboard2HeartFill, EyeFill, Flag, FlagFill, Link, PinAngleFill, PinFill, PlusCircleDotted } from 'react-bootstrap-icons'
import { NavLink, useParams } from 'react-router-dom'
import Authentication from '../../../../libs/api/services/Authentication'
import Patient from '../../../../libs/api/services/Patient'
import QuestionnaireAssignment from '../../../../libs/api/services/QuestionnaireAssignment'
import { ClaimsFilter } from '../../../../libs/authentication/ClaimsFilter'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import PatientContext from '../../patient/management/PatientProvider'
import QuestionnaireAssignmentAdmin from '../assignment/QuestionnaireAssignmentAdmin'

export default function PatientQuestionnaires() {
	const { id, questionair } = useParams()
	const { setSectionInfo } = useContext(CommonFunctionsContext)
	const { activePatient } = useContext(PatientContext)
	const [mode, setMode] = useState('')
	const [patient, setPatient] = useState()
	const [questionnaires, setQestionnaires] = useState([])
	const [loading, setLoading] = useState(true)


	const [filters,setFilters] = useState({
		name:undefined,
		assingned:undefined,
		complete:undefined,
	})

	const _handleOnAdd = (v) => {
		load()
		setTimeout(setMode, 300, '')
	}

	const _setupAdd = () => {
		Patient.GetById(id)
			.then((r) => {
				setPatient(r)
				setMode('Add')
			})

	}

	useEffect(() => {
		if (activePatient)
			setSectionInfo(`Questionnaires for ${activePatient.userProfile.firstName} ${activePatient.userProfile.lastName} at ${Authentication.getFacilityName()}`);
		else
			setSectionInfo(`Questionnaires`);
	}, [activePatient])

	const _checkPinned = (id) => {

		try {
			var quest = questionnaires.find(r => r.id === id)
			const isPinned = JSON.parse(quest.options.find(r => r.property === "PIN_TO_DASH").value)
			if (isPinned)
				return <button onClick={(e) => _handlePin(id, false)} className='btn btn-xs w-100 text-start text-primary'><PinFill />Unpin from patient dashboard </button>
		} catch (e) { }

		return <button onClick={(e) => _handlePin(id, true)} className='btn btn-xs w-100 text-start text-secondary'><PinAngleFill />Pin to patient dashboard </button>
	}

	const load = () => {
		QuestionnaireAssignment
			.GetPatientQuestionnairesByType(id, 'Questionnaire',filters)
			.then((r) => {
				setQestionnaires(r)
				setLoading(false)
			})
	}

	useEffect(() => {
		load()
	}, [filters])

	const _handlePin = (qid, val) => {
		QuestionnaireAssignment
			.SetAssignmentOption(qid, 'PIN_TO_DASH', val)
			.then((r) => {
				load()
			})
	}

	if (mode === "Add" && patient)
		return (<QuestionnaireAssignmentAdmin
			onDone={(v) => _handleOnAdd(v)}
			onCancel={(e) => setMode('')}
			skip={[2]}
			startAt={1}
			defaultValues={{ user: patient }}
		/>)
	else
		return (
			<div className='d-flex flex-column h-100'>
				<ClaimsFilter resources={[{ resource: "Questionnaires", type: 'Inherit-Edit' }, { resource: "Questionnaires", type: 'Edit' }]} claim={[]}>
					<div className='d-flex flex-row text-center p-3 bg-secondary-container flex-shrink-1'>

						<div
							onClick={(e) => _setupAdd()}
							style={{ cursor: 'pointer' }} className=' bg-primary-container m-2 p-2 rounded-3'>
							<PlusCircleDotted
							/> Assign a questionnaire
						</div>
						{/* <div style={{ cursor: 'pointer' }} className=' bg-primary-container m-2 p-2 shadow '>
						Assigned (100)
					</div>
					<div style={{ cursor: 'pointer' }} className=' bg-secondary-container m-2 p-2'>
						Complete (99)
					</div>
					<div style={{ cursor: 'pointer' }} className=' bg-secondary-container m-2 p-2'>
						Incomplete (1)
					</div> */}
					</div>
				</ClaimsFilter>
				<div className='row text-center mb-2 bg-primary-container flex-shrink-1' >
					<div className='col-1'>
						Alerts
					</div>
					<div className='col-3 d-flex flex-column'>
						<b>Name</b>
						<input onChange={e => setFilters({...filters,name: e.target.value === ''? undefined : e.target.value})} className='form-control form-control-sm m-2' placeholder='Search' />
					</div>
					<div className='col-3 d-flex flex-column'>
						<b>Assigned On</b>
						<input onChange={e => setFilters({...filters,assigned: !e.target.value ? undefined : e.target.value.toString()})} type='date' className='form-control form-control-sm m-2' placeholder='Search' />
					</div>
					<div className='col-3 d-flex flex-column'>
						<b>Completed On</b>
						<input onChange={e => setFilters({...filters,completed: !e.target.value ? undefined : e.target.value.toString()})}  type='date' className='form-control form-control-sm m-2' placeholder='Search' />
					</div>
					<div className='col-2'>
						<b>Options</b>
					</div>
				</div>
				<div style={{ overflow: 'auto', position: 'relative' }} className=' flex-grow-1'>
					<div className={'justify-content-center align-items-center position-absolute bg-primary-container '.concat(loading ? 'show-loading' : 'hide-loading')} style={{ left: '0px', top: '0px', right: '0px', bottom: '0px', zIndex: 1000 }}>
						<div className='text-center' >

							{/* <div>{itemsLoaded}/{totalItems}</div> */}
							<Clipboard2HeartFill size={75} />
							<div>
								<FontAwesomeIcon className='me-2' size='2x' icon={faSpinner} spinPulse />
								Loading patient questionnaires
							</div>
						</div>
					</div>
					{
						questionnaires.map((q) => q.resource &&
							<div className='row mb-1 text-center'>
								<div className='col-1'>
									{
										q.resource.alerts.length > 0
											?
											<FlagFill className='text-danger me-2' />
											:
											<Flag className='text-secondary me-2' />
									}

								</div>
								<div className='col-3 text-start'>

									{q.resource.questionnaire.name}
								</div>
								<div className='col-3'>
									{q.resource.assignedDate.substring(0, 19)}
								</div>
								<div className='col-3'>
									{q.resource.completedDate ? q.resource.completedDate.substring(0, 19) : ''}
								</div>
								<div className='col-2 text-center d-flex flex-column align-items-start '>
									<NavLink
										key={q.id}
										className={'btn btn-sm w-100 text-start text-primary'} tag={Link}
										// to={menuItems[i].location}
										to={'/Dashboard/Patient/' + id + '/Questionanire/' + q.resource.questionnaire.id + "/" + q.resource.id}
									>
										<EyeFill />View Questionnaire
									</NavLink>
									{_checkPinned(q.id)}
								</div>
							</div>
						)
					}
				</div>
			</div>
		)
}
